import React from "react";
import { Link } from "react-router-dom";

function AddOrganization() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">

      <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-sm">

        <img
          src="/images/logo.png"
          className="m-auto mb-10"
          alt="logo"
          width={200}
        />

        <h1 className="text-3xl text-center font-bold mb-10">
          Organization
        </h1>

        {/* Email */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Organization Name
          </label>
          <input
            type="text"
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Domain
          </label>
          <input
            type="text"
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Login Button */}
        <button className="bg-black text-white p-2 w-full rounded-md mb-3">
          Add New Organization
        </button>

      </div>
    </div>
  );
}

export default AddOrganization;
